import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const useBaiduAnalytics = () => {
  const location = useLocation();
  const firstRender = useRef(true);

  // 初始化百度统计脚本
  useEffect(() => {
    const baiduId = import.meta.env.VITE_BAIDU_ANALYTICS_ID;
    
    // 如果没有配置 ID，则不启用
    if (!baiduId) return;

    // 初始化 _hmt 数组
    window._hmt = window._hmt || [];

    // 检查是否已经注入脚本，避免重复
    if (document.getElementById('baidu-analytics-script')) return;

    const hm = document.createElement("script");
    hm.id = 'baidu-analytics-script';
    hm.src = `https://hm.baidu.com/hm.js?${baiduId}`;
    
    const s = document.getElementsByTagName("script")[0];
    if (s && s.parentNode) {
      s.parentNode.insertBefore(hm, s);
    }
  }, []);

  // 监听路由变化，手动上报 PV
  useEffect(() => {
    const baiduId = import.meta.env.VITE_BAIDU_ANALYTICS_ID;
    if (!baiduId) return;

    // 首次渲染跳过，因为脚本加载时会自动上报一次 PV
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    if (window._hmt) {
      const pageURL = location.pathname + location.search;
      window._hmt.push(['_trackPageview', pageURL]);
    }
  }, [location]);
};

export default useBaiduAnalytics;
